// 🚨 AUTO-GENERADO desde ProviderInvoiceDataType.ts - No editar manualmente

export const ProviderInvoiceFormDataKeys = [
  "id",
  "tipo",
  "respuesta",
  "fecha",
  "pagada",
  "numero",
  "subtotal",
  "impuestos",
  "descuento",
  "total",
  "sequence",
  "document_key",
  "exchange_rate",
  "status",
  "providerId",
  "provider",
  "providerInvoiceCategoryId",
  "providerInvoiceCategory",
  "currencyId",
  "currency",
  "providerNotes",
  "providerInvoicePayments",
  "providerRecibeId",
  "providerRecibe",
  "user",
  "reference_number"
] as const;
